import React from 'react'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import { ReactComponent as YqLogoGray } from 'ui/images/YQ_Logo_gray.svg'
import { useGlobal } from 'reactn'
import Error from 'ui/utils/Error'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    margin: 0,
    justifyContent: 'space-between',
  },
  contentWrapper: {
    backgroundColor: theme.palette.background.default,
    overflow: 'auto',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: 1,
  },
  footer: {
    minHeight: 120,
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

export type LayoutProps = {
  header: any
  children?: any
  showFooter?: boolean
}

/**
 * ヘッダ、フッタのあるレイアウト
 */
export const Layout: React.FC<LayoutProps> = ({
  header,
  children,
  showFooter,
}: LayoutProps) => {
  const [error] = useGlobal('error')
  const { classes } = useStyles()
  return (
    <>
      <div className={classes.root}>
        <div>{header}</div>
        <div className={classes.contentWrapper}>
          {error ? (
            <Error error={error} />
          ) : (
            <>
              <div className={classes.content}>{children}</div>
            </>
          )}
          {showFooter && (
            <div className={classes.footer}>
              <YqLogoGray />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
